module.exports = __webpack_public_path__ + "media/components/participants_visible_icon/static/checked-1b7cb79dbf59c01bd1127191c711e46c.png";